export default "__VITE_ASSET__DIrKuXBP__"